function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  id: "fluent-mdl2:embed"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M4.56055 5.81055L5.43945 6.68945L2.13867 10L5.43945 13.3105L4.56055 14.1895L0.361328 10L4.56055 5.81055ZM15.4395 5.81055L19.6387 10L15.4395 14.1895L14.5605 13.3105L17.8613 10L14.5605 6.68945L15.4395 5.81055ZM6.8457 17.5L11.8457 2.5H13.1543L8.1543 17.5H6.8457Z",
  fill: "#767A8A"
}));
const SvgEmbed = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmbed, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/embed.fe24fecb.svg";
export { ForwardRef as ReactComponent };